/* unplugin-vue-components disabled */import { render } from "./InviteBase.vue?vue&type=template&id=300536f1"
import script from "./InviteBase.vue?vue&type=script&lang=js"
export * from "./InviteBase.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__